export default "/images/template.svg?dc891273aa40a6684164139ae48aab93";